(function() {
    'use strict';
    var RxRefillBaseCtrl = function (autoInit, changePharmacyRoute, changePharmacyRouteOpts) {
        return function ($q, $scope, $stateParams, toaster, gettext, _, PatientPortalStorageRepository, PrescriptionService, TransitionManager, PatientSettingsService) {
            $scope.name = 'RxRefill';
            $scope.mapDisplay = false;
            $scope.loading = false;
            $scope.requestLoading = false;
            $scope.selectedPharmacy = {
                pharmacy: {
                    Name: '',
                    Address: {
                        Address1: '',
                        City: '',
                        State: '',
                        Zip: ''
                    },
                    Phone: {
                        PhoneNumber: ''
                    }
                }};
            $scope.patient = {Medications: [], Pharmacies: []};
            $scope.medFilters = PrescriptionService.medFilters;
            $scope.activeFilter = PrescriptionService.medFilters[1];

            var activePatient =  PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };
            $scope.featureList = PatientSettingsService.getPatientFeatures();

            function updateFilteredPrescriptions(filter) {
                $scope.activeFilter = filter;

                $scope.filteredPrescriptions = _.filter($scope.patient.Medications, function (item) {
                    return PrescriptionService.dateFilter(item.EndDate, $scope.activeFilter.Days) || !!item.RefillRequestPending;
                });
            }

            function pharmacyFormat(pharmacy) {
                var str = '';
                str += pharmacy.Name + ' ' + pharmacy.Address.Address1 + ' ' + pharmacy.Address.City + ' ' + pharmacy.Address.State + ' ' + pharmacy.Address.Zip;
                return str;
            }

            function changePharmacy(){
                TransitionManager.transition({appRoute: changePharmacyRoute, opts : changePharmacyRouteOpts || {id: activePatient.id}});
            }

            function extendPrescriptionList(medications) {
                var extendedList = _.map(medications, function (element) {
                    return _.assignIn(element,
                        {SelectedForRefillRequest:
                            (PrescriptionService.getSelectedMedId() === element.RelPatientMedicationId || !!element.RefillRequestPending)});
                });
                return extendedList;
            }

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                PatientPortalStorageRepository.getActivePatient();
                var pharmaciesPromise = PrescriptionService.getPharmacies(activePatient.id)
                    .then(function (data) {
                        $scope.patient.Pharmacies = data.plain();
                        if ($scope.patient.Pharmacies && $scope.patient.Pharmacies.length) {
                            $scope.selectedPharmacy.pharmacy = _($scope.patient.Pharmacies)
                                .filter({'IsPreferredPharmacy': true})
                                .value();
                            $scope.selectedPharmacy.pharmacy = $scope.selectedPharmacy.pharmacy.length ? $scope.selectedPharmacy.pharmacy[0] : $scope.patient.Pharmacies[0];
                            toggleMapDisplay(true);
                        }
                    });
                var rxRefillsPromise = PrescriptionService.getRxRefills(activePatient.id)
                    .then(function (data) {
                        $scope.patient.Medications = data.Medications;

                        //prescriptions.html
                        var splitPrescriptions = _.partition($scope.patient.Medications, function (item) {
                            return PrescriptionService.dateFilter(item.EndDate, PrescriptionService.medFilters[1].Days);
                        });
                        $scope.currentPrescriptions = splitPrescriptions[0];
                        $scope.previousPrescriptions = splitPrescriptions[1];

                        //prescriptionsList.html
                        updateFilteredPrescriptions($scope.activeFilter);

                        //rxRefills.html
                        if ($scope.patient.Medications && $scope.patient.Medications.length) {
                            $scope.orderedPrescriptions = $scope.currentPrescriptions.concat($scope.previousPrescriptions);
                            $scope.orderedPrescriptions  = extendPrescriptionList($scope.orderedPrescriptions);
                        }
                    });

                auditMedications(reportRequestDto);

                $q.all([pharmaciesPromise, rxRefillsPromise]).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            function auditMedications(reportRequestDto) {
                PrescriptionService.auditMedicationsLogging(reportRequestDto);
            }

            function medCheck(med) {
                med.SelectedForRefillRequest = !med.SelectedForRefillRequest;
            }

            function medSelect(med) {
                PrescriptionService.setSelectedMedId(med.RelPatientMedicationId);
            }

            function toggleMapDisplay(bool) {
                $scope.mapDisplay = bool;
            }

            function rxRefillRequest() {
                $scope.requestLoading = true;
                var rxRefills = {
                    PatientId: activePatient.id,
                    CreatedById: loginUser.id,
                    RequestedPharmacyId: $scope.selectedPharmacy.pharmacy.Id,
                    Reason: $scope.Reason,
                    Medications: _($scope.patient.Medications)
                        .filter({'SelectedForRefillRequest': true})
                        .map(function (med) {
                            return {
                                RelPatientMedicationId: med.RelPatientMedicationId,
                                DrugName: med.DrugName,
                                Instructions: med.Instructions,
                                ProviderId: med.ProviderId
                            };
                        })
                        .value()
                };

                if (rxRefills.Medications.length === 0) {
                    toaster.pop('warning', '', gettext('No medications selected.'));
                    $scope.requestLoading = false;
                } else {
                    PrescriptionService
                        .putRxRefills(rxRefills)
                        .then(function (data) {
                            PrescriptionService.clearSelectedMedId();
                            $scope.patient.Medications = data.Medications;
                            toaster.pop('success', '', gettext('Refill request sent successfully.'));
                            TransitionManager.transition({appRoute: 'prescriptions'});
                        })
                        .catch(function () {
                            toaster.pop('error', '', gettext('An error occurred while sending the refill request'));
                        })
                        .finally(function () {
                            $scope.requestLoading = false;
                        });
                }
            }

            $scope.tileState = {
                isCollapsed: undefined
            };
            $scope.toggleState = function() {
                if($scope.tileState.isCollapsed === undefined)
                {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            if(autoInit) {
                initialize();
            }

            $scope.auditMedications = auditMedications;
            $scope.updateFilteredPrescriptions = updateFilteredPrescriptions;
            $scope.pharmacyFormat = pharmacyFormat;
            $scope.medCheck = medCheck;
            $scope.medSelect = medSelect;
            $scope.rxRefillRequest = rxRefillRequest;
            $scope.changePharmacy = changePharmacy;
        };
    };
    
    var RxRefillCtrl = new RxRefillBaseCtrl(true, 'myChartPersonalDetails');
    var RxRefillMobileChartCtrl = function ($q, $scope, $stateParams, toaster, gettext, _, PatientPortalStorageRepository, PrescriptionService, TransitionManager, PatientSettingsService, $modal) {
        new RxRefillBaseCtrl(false, 'myChartMobile', { openPD: true }).call(this, $q, $scope, $stateParams, toaster, gettext, _, PatientPortalStorageRepository, PrescriptionService, TransitionManager, PatientSettingsService);
        $scope.viewModal = function(patientMedicationId) {
            var modalInstance = $modal.open({
                templateUrl: '/mychart/views/mobile/genericModal.html',
                controller: 'GenericModalCtrl',
                scope: $scope,
                resolve: {
                    canPrint: function() {
                        return false;
                    },
                    modalContent: function () {
                        var patientMedication = _.find($scope.filteredPrescriptions, { RelPatientMedicationId: patientMedicationId });
                        var modalContent =
                                '<div>' + new Date(patientMedication.StartDate).toLocaleDateString() + ' - ' + new Date(patientMedication.EndDate).toLocaleDateString() + '</div>' +
                                '<div>' + patientMedication.DrugName + '</div>' +
                                '<div>' + patientMedication.Instructions + '</div>';
                        return modalContent;
                    }
                }
            });
            modalInstance.result.then(function() {
            });
        };
    };
    var RxRefillMobileCtrl = function ($q, $scope, $stateParams, toaster, gettext, _, PatientPortalStorageRepository, PrescriptionService, TransitionManager, PatientSettingsService) {
        new RxRefillBaseCtrl(true, 'myChartMobile', { openPD: true }).call(this, $q, $scope, $stateParams, toaster, gettext, _, PatientPortalStorageRepository, PrescriptionService, TransitionManager, PatientSettingsService);
    };
    
    angular.module('rxrefills').controller('RxRefillCtrl',
    ['$q', '$scope', '$stateParams', 'toaster', 'aprgettext', '_', 'PatientPortalStorageRepository', 'PrescriptionService', 'TransitionManager', 'PatientSettingsService',
        RxRefillCtrl]);
    angular.module('rxrefills').controller('RxRefillMobileCtrl',
    ['$q', '$scope', '$stateParams', 'toaster', 'aprgettext', '_', 'PatientPortalStorageRepository', 'PrescriptionService', 'TransitionManager', 'PatientSettingsService',
        RxRefillMobileCtrl]);
    angular.module('rxrefills').controller('RxRefillMobileChartCtrl',
    ['$q', '$scope', '$stateParams', 'toaster', 'aprgettext', '_', 'PatientPortalStorageRepository', 'PrescriptionService', 'TransitionManager', 'PatientSettingsService', '$uibModal',
        RxRefillMobileChartCtrl]);
})();
